import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { UpdateUserMfaMutationArgs } from 'tuapath-common/generated/schema';
import { User } from '../../dto';

type Result = { user: User };
type Variables = UpdateUserMfaMutationArgs;
export function useUpdateUserMfa(options?: MutationHookOptions<Result, Variables>) {
  const mutation = gql`
    mutation updateUserMfa($input: UserMfaInput!) {
      updateUserMfa(input: $input) {
        user {
          id
          twoFactorEnabled
          mfaConfig {
            emailOTP
            smsOTP
            totp
            passkey
            smsOtpEnabled
            totpEnabled
            passkeyEnabled
            enabled
          }
        }
    }
    }
  `;

  return useMutation<Result, Variables>(mutation, options);
}

export default useUpdateUserMfa;

